/**
 * Strings module for voice-chat-ui
 * Provides localized strings for all UI components
 */
import { strings as en, type Strings } from "./en";

// Re-export the default (English) strings
export { en as strings };
export type { Strings };

// Type for nested string access
type NestedKeyOf<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${NestedKeyOf<T[K]>}`
          : K
        : never;
    }[keyof T]
  : never;

export type StringKey = NestedKeyOf<Strings>;

/**
 * Get a string by dot-notation key
 * For future i18n support, this can be extended to support multiple locales
 *
 * @example
 * getString("startSheet.buttonStart") // "Start Call"
 * getString("pausedSheet.title") // "Coffee Break?"
 */
export function getString(key: string, _locale = "en"): string {
  const keys = key.split(".");
  let value: unknown = en;

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = (value as Record<string, unknown>)[k];
    } else {
      // Return the key itself if not found (useful for debugging)
      return key;
    }
  }

  return typeof value === "string" ? value : key;
}
